
<template>
  <!-- <div class="example"> -->
  <md-speed-dial md-direction="bottom" class="md-top-right">
    <md-speed-dial-target @click="add" class="uLarge md-round md-just-icon md-info">
      <md-icon>add</md-icon>
    </md-speed-dial-target>

    <!-- <md-speed-dial-content>

        <md-button v-for=" ftb in ftbOptions" :key="ftb.name" :to="ftb.path" class=" md-info uMedium md-icon-button md-round md-just-icon" >
          <md-icon >{{ftb.icon}}</md-icon>
        </md-button>


    </md-speed-dial-content>-->
  </md-speed-dial>

  <!-- <md-speed-dial v-else  md-direction="bottom" class="md-top-right"> -->
  <!-- <md-speed-dial-target @click="add" class="uLarge md-round md-just-icon md-info" >
        <md-icon>add</md-icon>
      </md-speed-dial-target>

      <md-speed-dial-content>

        <md-button v-for=" ftb in ftbOptions" :key="ftb.name" :to="ftb.path" class="md-info uMedium md-icon-button md-round md-just-icon" >
          <md-icon >{{ftb.icon}}</md-icon>
        </md-button>
  </md-speed-dial-content>-->
  <!-- </md-speed-dial> -->
  <!-- </div> -->
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Ftb",
  data() {
    return {
      isMobile: false
    };
  },
  computed: {
    ...mapGetters({
      ftbOptions: "ftbOptions"
    })
  },
  methods: {
    add() {
      let target = "";
      switch (this.$route.name) {
        case "Clients":
          target = "/client";
          break;
        case "Servers":
          target = "/server";
          break;
      }
      this.$router.push(target);
    }
  }
};
</script>

<style lang="scss" scoped>
// .example {
//   min-height: 180px;
// }
.md-button.uLarge i {
  font-size: 2rem !important;
}
.md-button.uMedium i {
  font-size: 1.5rem !important;
}
.md-button.uLarge {
  height: 50px;
  width: 50px;
  border-radius: 25px;
}
@media screen and (min-width: 600px) {
  .md-button.uLarge {
    height: 4rem;
    width: 4rem;
    border-radius: 2rem;
  }
}
.md-speed-dial {
  // margin: 0 24px 0 8px;
  // right: 1rem;
  // bottom: 3rem;
}

.md-speed-dial {
  z-index: 9;
  flex-direction: row;
  bottom: unset;

  top: 0.5rem;

  // top: 60px;
  // right: 25px;
}
</style>